const messages = {
  'header.brand': 'Auryc',
  'header.signup': '注册',
  'header.login': '登陆',
  'header.lang': '语言',
  'header.search': '搜一搜',
  'header.xn_dashboard': '主面板',
  'header.xn_realtime': '实时',
  'header.xn_brand': '小能科技',

  'feature.products': '产品介绍',
  'feature.customers': '我们的客户',
  'feature.developers': '开发',
  'feature.support': '用户支持',
  'feature.about': '我们的团队',

  'feature.xiaoneng': '小能分析',
  'feature.dashboard': '综合面板',
  'feature.apps': '分类工具',
  'feature.insights': '深入分析',
  'feature.users': '用户管理',
  'feature.alerts': '报警管理',
  'feature.feedback': '用户反馈'
};

export default messages;



/** WEBPACK FOOTER **
 ** ./src/locales/zh/messages.js
 **/